import React, { useEffect, useState } from 'react';

/** Suggested candidates from the server plus directory search. Only opaque tokens are sent back. */
export default function FundCandidateSelector({ row, onSearch, onChoose, onCancel, busy, isClient = false }) {
  const [q, setQ] = useState('');
  const [results, setResults] = useState(row.candidates);
  const [hint, setHint] = useState(false);
  const [state, setState] = useState('idle');

  useEffect(() => {
    if (q.trim().length < 2) { setResults(row.candidates); setHint(false); return undefined; }
    let live = true;
    setState('searching');
    const t = setTimeout(async () => {
      try { const r = await onSearch(q.trim()); if (live) { setResults(r.results); setHint(r.excludedTypeHint); setState('idle'); } }
      catch (e) { if (live) setState('error'); }
    }, 250);
    return () => { live = false; clearTimeout(t); };
  }, [q]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="phc-selector">
      <label className="phc-small" htmlFor={`phc-s-${row.positionRef}`}>Which fund is “{row.originalName}”?</label>
      <input
        id={`phc-s-${row.positionRef}`}
        className="phc-input"
        placeholder="Search scheme name"
        value={q}
        disabled={isClient}
        onChange={(e) => !isClient && setQ(e.target.value)}
        autoFocus={!isClient}
      />
      {hint && <p className="phc-small">That looks like a fund type outside stock overlap. Choosing it keeps it in the inventory but excludes it from comparison.</p>}
      {state === 'searching' && <p className="phc-small">Searching…</p>}
      {state === 'error' && <p className="phc-error">Search failed. Try again.</p>}
      <ul className="phc-candidates">
        {results.map((c) => (
          <li key={c.token}>
            <button type="button" disabled={busy || isClient} onClick={() => !isClient && onChoose(c.token)}>
              <span>{c.name}</span>
              <span className="phc-small">{[c.amc, c.category, c.eligible ? 'compared' : 'not compared'].filter(Boolean).join(' · ')}</span>
            </button>
          </li>
        ))}
        {!results.length && state === 'idle' && <li className="phc-small">No matching fund. Try a shorter name.</li>}
      </ul>
      {!isClient && (
        <button type="button" className="phc-link" onClick={onCancel}>Cancel</button>
      )}
    </div>
  );
}
